import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SignInOptions } from "@/components/SignInOptions";
import { useAuth } from "@/lib/auth";

export const AuthDialog = () => {
  const { user } = useAuth();
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const onOpen = (event) => setOptions({ reason: "", next: "", ...(event.detail || {}) });
    window.addEventListener("dcyb:open-auth", onOpen);
    return () => window.removeEventListener("dcyb:open-auth", onOpen);
  }, []);

  useEffect(() => { if (user) setOptions(null); }, [user]);

  if (!options) return null;
  return (
    <Dialog open onOpenChange={(open) => { if (!open) setOptions(null); }}>
      <DialogContent data-testid="auth-dialog" className="rounded-none max-w-md w-[calc(100%-2rem)] border-[#D2D5DA] p-0 gap-0">
        <div aria-hidden="true" className="h-1.5 w-full bg-[#0FBF77]" />
        <DialogHeader className="px-6 pt-5 pb-4 border-b hairline text-left space-y-2">
          <div className="flex items-start gap-3">
            <img src="/dcyb-mark.png" alt="" width={44} height={44} className="w-11 h-11 object-contain shrink-0" />
            <div>
              <DialogTitle data-testid="auth-dialog-title" className="font-display text-xl sm:text-2xl font-extrabold tracking-normal text-[#0F141B] leading-tight">Sign in to DCYB</DialogTitle>
              <DialogDescription data-testid="auth-dialog-description" className="mt-1 text-xs text-[#5F6168]">{options.reason || "Use your email or Google. Free, no password."}</DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="px-6 py-5"><SignInOptions idPrefix="auth-dialog" next={options.next || undefined} /></div>
      </DialogContent>
    </Dialog>
  );
};
